<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="contact-person content-wrapper">
      <div class="page-header">{{ $t('newContactPerson') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'AgentContactPersonList' }">{{ $t('contactPerson') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newContactPerson') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 600px">
        <el-form-item :label="$t('firstName')" :required="true">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.firstName" class="input-with-select">
                <el-select v-model="contactPerson.title" slot="prepend" :placeholder="$t('title')" style="width: 105px">
                  <el-option label="Mr." value="Mr."></el-option>
                  <el-option label="Mrs." value="Mrs."></el-option>
                  <el-option label="Miss." value="Miss."></el-option>
                  <el-option label="Ms." value="Ms."></el-option>
                  <el-option label="Other" value=" "></el-option>
                </el-select>
              </el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('lastName')">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.lastName"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('position')">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.position"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :key="`contact-person-email-${index}`" v-for="(email, index) in contactPerson.emailList" :label="bindLabel(index, $t('email'))">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.emailList[index]"></el-input>
            </el-col>
            <el-col v-if="index > 0" :span="4" >
              <el-button type="danger" style="margin-left: 5px;" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('emailList', index)"></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="4">
              <el-button type="primary" size="mini" icon="el-icon-plus"  plain @click="onAddMoreItemButtonClick('emailList')">{{$t('addEmail')}}</el-button>
            </el-col>
            <el-col :span="20"></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :key="`contact-person-mobile-${index}`" v-for="(mobile, index) in contactPerson.mobileList" :label="bindLabel(index, $t('mobile'))">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.mobileList[index]"></el-input>
            </el-col>
            <el-col v-if="index > 0" :span="4" >
              <el-button type="danger" style="margin-left: 5px;" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('mobileList', index)"></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="4">
              <el-button type="primary" size="mini" icon="el-icon-plus"  plain @click="onAddMoreItemButtonClick('mobileList')">{{$t('addMobile')}}</el-button>
            </el-col>
            <el-col :span="20"></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('phone')">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.phone"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('fax')">
          <el-row>
            <el-col :span="20">
              <el-input v-model="contactPerson.fax"></el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" @click="onCreateContactPersonButtonClick">{{ $t('create') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Agent/ManageAgent/ContactPerson/Add.i18n'
import AgentContactPersonApi from '@/api/agent/contact-person-api'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import { mapState } from 'vuex'
import { map, trim } from 'lodash'

export default {
  name: 'AgentContactPersonAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    this.isLoading = true

    if (this.activeAgentId === undefined || this.activeAgentId === '') {
      this.$router.push({
        name: 'AgentList'
      })
    }

    this.isLoading = false
  },
  computed: {
    ...mapState({
      activeAgentId: state => state.general.activeAgentId
    })
  },
  data () {
    return {
      isLoading: false,
      STATUS,
      contactPerson: {
        title: 'Mr.',
        firstName: '',
        lastName: '',
        position: '',
        emailList: [''],
        mobileList: [''],
        phone: '',
        fax: ''
      }
    }
  },
  methods: {
    onCreateContactPersonButtonClick: async function () {
      try {
        this.startLoading()

        const filteredDataList = this._filterDataList()
        const contactPersonData = Object.assign({}, this.contactPerson, filteredDataList)
        await AgentContactPersonApi.create(this.activeAgentId, contactPersonData)

        this.$router.push({
          name: 'AgentContactPersonList'
        })

        const title = this.$t('createContactPersonSuccessTitle')
        const message = this.$t('createContactPersonSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'AgentContactPersonList'
      })
    },
    bindLabel: function (index, defaultLabel) {
      return (index === 0) ? defaultLabel : ''
    },
    onAddMoreItemButtonClick: function (keyItem) {
      this.contactPerson[keyItem].push('')
    },
    onRemoveItemButtonClick: function (keyItem, index) {
      this.contactPerson[keyItem].splice(index, 1)
    },
    _filterDataList: function () {
      const emailList = map(this.contactPerson.emailList, trim)
      const mobileList = map(this.contactPerson.mobileList, trim)

      const filteredEmailList = emailList.filter(email => email !== '')
      const filteredMobileList = mobileList.filter(mobile => mobile !== '')

      const filteredDataList = {
        emailList: filteredEmailList,
        mobileList: filteredMobileList
      }

      return filteredDataList
    }
  }
}
</script>

<style>
  .el-form > div {
    text-align: left;
  }
</style>
